export type IssuesListProps = {
  failed: 1 | 0;
  flaky: 1 | 0;
  slow: 1 | 0;
};

type IssueContentProps = {
  issue: keyof IssuesListProps;
};

type IssueDescriptionProps = {
  editThresholdUrl: string;
  threshold: number;
};

const DescriptionFlaky = () => {
  return (
    <>
      Flaky tests occur when a result toggles unpredictably between pass and
      fail without any code changes.
    </>
  );
};

const DescriptionFailed = () => {
  return (
    <>
      A failed test result need not ignite panic. This is usually an easy fix.
      However, it is currently impacting your test performance and overall
      efficiency.
    </>
  );
};

const DescriptionSlow = ({
  threshold,
  editThresholdUrl,
}: IssueDescriptionProps) => {
  return (
    <>
      This test appears to be an outlier in slowness. A run is flagged as slow
      when the slowest 1% of tests take more than {threshold}% of the total run
      time —{" "}
      <a
        href={editThresholdUrl}
        className="bold color-inherit"
        target="_blank"
        rel="noreferrer"
      >
        change this metric.
      </a>
    </>
  );
};

export const getIssueDescription = ({
  issue,
  editThresholdUrl,
  threshold,
}: IssueContentProps & IssueDescriptionProps) => {
  const contents = {
    flaky: <DescriptionFlaky />,
    failed: <DescriptionFailed />,
    slow: (
      <DescriptionSlow
        threshold={threshold}
        editThresholdUrl={editThresholdUrl}
      />
    ),
  };

  return contents[issue];
};

export const getIssueContent = ({ issue }: IssueContentProps) => {
  const contents = {
    flaky: {
      title: "Flaky",
      emoji: "🔥",
    },
    failed: {
      title: "Failed",
      emoji: "❌",
    },
    slow: {
      title: "Significantly slow",
      emoji: "🐢",
    },
  };

  return contents[issue];
};
